export default __webpack_public_path__ + "static/media/shock_action.44bd7bf3.png";